import { useEffect } from 'react';
import { fieldNames } from '../../../../shared/configs/acceptanceForm';
import {
  useFieldArrayMethods,
  useFormMethods,
  useFormWatch,
} from '../../../../../../helpers/formManager';
import { defaultIntervalAvailability } from '../../../../shared/configs/selectionData/intervalAvailabilities';
import { defaultIntervalMode } from '../../../../shared/configs/selectionData/intervalModes';
import { useTimeIntervals } from '../../../../services/timeIntervals';

const {
  active: activeName,
  intervalId: intervalIdName,
  mode: modeName,
  availability: availabilityName,
  from: fromName,
  to: toName,
} = fieldNames.scheduleSettingInterval;

const UpdateIntervals = ({ observableNames, intervalsName, children }) => {
  const [from, to, duration] = useFormWatch({ name: observableNames });

  const { getValues } = useFormMethods();

  const { append, remove, replace } = useFieldArrayMethods();

  const timeIntervals = useTimeIntervals();

  useEffect(() => {
    const currentIntervals = getValues(intervalsName) ?? [];

    const hasIntervals = currentIntervals.length > 0;
    const hasData = Boolean(duration && from && to);

    if (!hasData) {
      if (hasIntervals) {
        remove();
      }

      return;
    }

    const currentIntervalsMap = hasIntervals
      ? new Map(currentIntervals.map((i) => [i[intervalIdName], i]))
      : undefined;

    const intervals = timeIntervals.createIntervals({
      duration,
      from,
      to,
      creator: getFieldsCreator(currentIntervalsMap),
    });

    if (!intervals) return;

    const apply = hasIntervals ? replace : append;

    const timeoutId = setTimeout(() => {
      apply(intervals);
    });

    return () => {
      clearTimeout(timeoutId);
    };
  }, [
    append,
    duration,
    from,
    getValues,
    intervalsName,
    remove,
    replace,
    to,
    timeIntervals,
  ]);

  return children;
};

export default UpdateIntervals;

function getFieldsCreator(currentIntervalsMap) {
  return (i) => {
    return (
      currentIntervalsMap?.get(i.id) ?? {
        [activeName]: true,
        [intervalIdName]: i.id,
        [modeName]: defaultIntervalMode,
        [availabilityName]: defaultIntervalAvailability,
        [fromName]: i.from.value,
        [toName]: i.to.value,
      }
    );
  };
}
